const Loader = () => {
    return <div className="shimmer-card">
        <div className="shimmer-element" />
        <div className="shimmer-element" />
        <div className="shimmer-element" />
        <div className="shimmer-element" />

    </div>
}
export default Loader;